import { __assign, __rest } from "tslib";
import React from 'react';
import VeltReactionPinTooltipUserAvatarWireframe from './VeltReactionPinTooltipUserAvatarWireframe/VeltReactionPinTooltipUserAvatarWireframe';
import VeltReactionPinTooltipUserNameWireframe from './VeltReactionPinTooltipUserNameWireframe/VeltReactionPinTooltipUserNameWireframe';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltReactionPinTooltipUserWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-reaction-pin-tooltip-user-wireframe", __assign({}, transformedProps), children));
};
VeltReactionPinTooltipUserWireframe.Avatar = VeltReactionPinTooltipUserAvatarWireframe;
VeltReactionPinTooltipUserWireframe.Name = VeltReactionPinTooltipUserNameWireframe;
export default VeltReactionPinTooltipUserWireframe;
